export default function Table({ children }) {
  return (
    <div className="w-full overflow-x-auto rounded border border-white-200">
      <table className="min-w-full border-collapse">{children}</table>
    </div>
  );
}

export const Th = ({ children, className = "" }) => {
  return (
    <th
      className={`py-3 px-4 bg-white-200 text-black-300 text-xs font-semibold uppercase tracking-wide text-left border-b border-white-300 ${className}`}
    >
      {children}
    </th>
  );
};

export const Td = ({ children, className = "" }) => {
  return (
    <td
      className={`py-3 px-4 border-b border-white-200 text-sm ${className}`}
    >
      {children}
    </td>
  );
};
